export const fmtDate = (d: string | Date | null | undefined): string =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "-";

export const fmtDateTime = (d: string | Date | null | undefined): string =>
  d
    ? new Date(d).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

export const fmtScore = (total: number | null | undefined, max: number | null | undefined): string =>
  total == null || max == null ? "-" : `${trimNum(total)} / ${trimNum(max)}`;

const trimNum = (n: number) => (Number.isInteger(Number(n)) ? String(Number(n)) : Number(n).toFixed(2));

/** multi_text answers are stored as JSON arrays — render them readably. */
export const prettyAnswer = (s: string | null | undefined): string => {
  if (!s) return "-";
  const t = s.trim();
  if (t.startsWith("[")) {
    try {
      const arr = JSON.parse(t);
      if (Array.isArray(arr)) return arr.map((x) => String(x).trim() || "-").join(", ");
    } catch {
      /* fall through */
    }
  }
  return t;
};

export const STATUS_LABELS: Record<string, string> = {
  created: "Link created",
  in_progress: "In progress",
  submitted: "Awaiting evaluation",
  evaluated: "Evaluated",
};
